'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_crud$Update$() {
}
export { $c_Lpresto_crud$Update$ as $c_Lpresto_crud$Update$ };
$p = $c_Lpresto_crud$Update$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_crud$Update$;
/** @constructor */
function $h_Lpresto_crud$Update$() {
}
export { $h_Lpresto_crud$Update$ as $h_Lpresto_crud$Update$ };
$h_Lpresto_crud$Update$.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return (-1754979095);
});
$p.l = (function() {
  return "Update";
});
$p.r = (function() {
  return 0;
});
$p.s = (function() {
  return "Update";
});
$p.j = (function(n) {
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lpresto_crud$Update$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_crud$Update$, "presto.crud$Update$", ({
  VA: 1,
  cy: 1,
  b: 1,
  c: 1,
  a: 1,
  e: 1,
  g: 1,
  m: 1
}));
export { $d_Lpresto_crud$Update$ as $d_Lpresto_crud$Update$ };
var $n_Lpresto_crud$Update$;
function $m_Lpresto_crud$Update$() {
  if ((!$n_Lpresto_crud$Update$)) {
    $n_Lpresto_crud$Update$ = new $c_Lpresto_crud$Update$();
  }
  return $n_Lpresto_crud$Update$;
}
export { $m_Lpresto_crud$Update$ as $m_Lpresto_crud$Update$ };
//# sourceMappingURL=presto.crud$-Update$.js.map
